import React, { useEffect, useState } from "react";
import "./users.scss";

import { getUserSessionStatsWS } from "./userApi";
import { gestioneSnackbar } from "../../utils/common";

import { Box, Grid, Stack, Typography } from "@mui/material";
import { isEmpty } from "../../utils/validation";

import GridBox from "../../components/gridBox/GridBox";
import UserFilter from "./components/userFilter/UserFilter";
import BoxFrequenceAccess from "./components/boxFrequenceAccess/BoxFrequenceAccess";
import BoxDistributionAccessHour from "./components/boxDistributionAccessHour/BoxDistributionAccessHour";
import BoxDistributionAccessDayOfWeek from "./components/boxDistributionAccessDayOfWeek/BoxDistributionAccessDayOfWeek";
import BoxDistributionDevices from "./components/BoxDistributionDevices/BoxDistributionDevices";
import BoxDistributionViewedPages from "./components/boxDistributionViewedPages/BoxDistributionViewedPages";
import BoxNumberUser from "./components/boxNumberUser/BoxNumberUser";
import BoxDistributionAge from "./components/boxDistributionAge/BoxDistributionAge";
import BoxDistributionRegistration from "./components/boxDistributionRegistration/BoxDistributionRegistration";

const Users = () => {
  const [type, setType] = useState("general");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [data, setData] = useState([]);

  const refreshContent = ({ type, start, end }) => {
    getUserSessionStatsWS({ type, start, end })
      .then((res) => setData(res))
      .catch((err) => gestioneSnackbar(true, err, "error"));
  };

  useEffect(() => {
    refreshContent({ type, start, end });
  }, []);

  console.log(data);

  return (
    <Box>
      <Stack gap={2}>
        <UserFilter
          type={type}
          setType={setType}
          startDateTime={start}
          setStartDateTime={setStart}
          endDateTime={end}
          setEndDateTime={setEnd}
          APICall={() => refreshContent({ type, start, end })}
        />
        <Stack gap={1}>
          <Typography variant="h4" sx={{ fontWeight: 500 }}>
            Sessioni:
          </Typography>
          <Grid container spacing={2}>
            {!isEmpty(data.frequence_access) && !isEmpty(data.number_user) ? (
              <Stack gap={2}>
                <GridBox
                  title={"Numero Utenti:"}
                  tooltip={data.number_user.tooltip}
                  size={{ xs: 12, sm: 6, md: 4 }}
                  body={<BoxNumberUser data={data.number_user} />}
                />
                <GridBox
                  title={"Frequenza Accessi:"}
                  tooltip={data.frequence_access.tooltip}
                  size={{ xs: 12, sm: 6, md: 4 }}
                  body={<BoxFrequenceAccess data={data.frequence_access} />}
                />
              </Stack>
            ) : null}
            {!isEmpty(data.distribution_access_hour) ? (
              <GridBox
                title={"Distribuzione orari di accesso:"}
                tooltip={data.distribution_access_hour.tooltip}
                size={{ xs: 12, sm: 6, md: 4 }}
                body={
                  <BoxDistributionAccessHour
                    data={data.distribution_access_hour.distribution}
                  />
                }
              />
            ) : null}
            {!isEmpty(data.distribution_access_day_of_week) ? (
              <GridBox
                title={"Distribuzione accessi settimanali:"}
                tooltip={data.distribution_access_day_of_week.tooltip}
                size={{ xs: 12, sm: 6, md: 4 }}
                body={
                  <BoxDistributionAccessDayOfWeek
                    data={data.distribution_access_day_of_week.distribution}
                  />
                }
              />
            ) : null}
            {!isEmpty(data.distribution_devices) ? (
              <GridBox
                title={"Distribuzione device:"}
                tooltip={data.distribution_devices.tooltip}
                size={{ xs: 12, sm: 6, md: 4 }}
                body={
                  <BoxDistributionDevices
                    data={data.distribution_devices.distribution}
                  />
                }
              />
            ) : null}
            {!isEmpty(data.distribution_of_pages_viewed) ? (
              <GridBox
                title={"Distribuzione device:"}
                tooltip={data.distribution_of_pages_viewed.tooltip}
                size={{ xs: 12, sm: 6, md: 4 }}
                body={
                  <BoxDistributionViewedPages
                    data={data.distribution_of_pages_viewed.distribution}
                  />
                }
              />
            ) : null}
          </Grid>
        </Stack>
        <Stack gap={1}>
          <Typography variant="h4" sx={{ fontWeight: 500 }}>
            Utenti:
          </Typography>
          <Grid container spacing={2}>
            {!isEmpty(data.distribution_age) ? (
              <GridBox
                title={"Distribuzione età utenti:"}
                tooltip={data.distribution_age.tooltip}
                size={{ xs: 12, sm: 6, md: 4 }}
                body={
                  <BoxDistributionAge
                    data={data.distribution_age.distribution}
                  />
                }
              />
            ) : null}
            {!isEmpty(data.distribution_new_user) ? (
              <GridBox
                title={"Registrazioni nel sistema:"}
                tooltip={data.distribution_new_user.tooltip}
                size={{ xs: 12, sm: 6, md: 4 }}
                body={
                  <BoxDistributionRegistration
                    data={data.distribution_new_user.distribution}
                  />
                }
              />
            ) : null}
          </Grid>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Users;
